import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getVerifyOtpCodePath = () => {
  return urlHelper('/auth/otp-code');
};
